import PagesHeader from "./components/PagesHeader";
import ProjectContent from "./project-components/ProjectContent";
import BackToTopButton from "./components/BackToTopButton";
import ProjectData from "./components/ProjectData";

const ProjectPage = () => {

    document.title = "Projects - Michael";

    return (
        <div className="dark:bg-[#121212]">
            <PagesHeader />
            {/* <ProjectContent/> */}
            <ProjectData />
            <BackToTopButton />
        </div>
    );
}

export default ProjectPage;